import React from 'react';
import InfoPopupHeaderSetting from '../../components/InfoPopupHeaderSetting';
import { globalFormat } from '../../../../utils/formatting';

interface IProps {
  durationStartDate: string;
}

export default ({ durationStartDate }: IProps) => {
  const { dateFormat } = globalFormat.getGlobalFormat();
  const formattedCohortDurationStartDate = globalFormat.formatDate(
    durationStartDate,
    { dateFormat },
  );
  return (
    <InfoPopupHeaderSetting label="Since">
      {formattedCohortDurationStartDate}
    </InfoPopupHeaderSetting>
  );
};
